import LogoCombinedView from './LogoCombinedView'

export default LogoCombinedView
